import styles from "./styles.module.scss";

import { DocumentsProps } from "./types";
import { ModalProvider } from "../../contexts/modal/index.context";
import { SignModalProvider } from "../../contexts/sign-modal/index.context";
import { SessionProvider } from "../../contexts/session/index.context";
import {
  TableProvider,
  TableContext,
} from "../../contexts/table/index.context";
//Components
import DatePickers from "../ui/datapickers";
import DocumentsButtons from "../ui/documents-buttons";
import Table from "../ui/table";
import SubTable from "../ui/table/sub-table";

export default function Documents(props: DocumentsProps) {
  return (
    <ModalProvider>
      <SignModalProvider>
        <SessionProvider url={props.url}>
            <div style={{display: "flex"}}>
              {props.url !== "/documents/list-of-documents" && <DocumentsButtons />}
              {/* <DocumentsButtons /> */}
                <DatePickers url={props.url} />
            </div>
            <Table url={props.url} />
            <SubTable url={props.url}/>
        </SessionProvider>
      </SignModalProvider>
    </ModalProvider>
  );
}
